export const initialResumeState = {
  personalInfo: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    linkedin: '',
    website: '',
    summary: '',
  },
  experience: [],
  education: [],
  skills: [],
  sectionsOrder: ['experience', 'education', 'skills'],
  customSections: [],
};

export const sampleResumeState = {
  personalInfo: {
    firstName: 'Alex',
    lastName: 'Morgan',
    email: 'alex.morgan@example.com',
    phone: '+1 (555) 123-4567',
    linkedin: 'linkedin.com/in/alexmorgan',
    website: 'alexmorgan.dev',
    summary: 'Experienced Software Engineer with a passion for building scalable web applications and intuitive user interfaces. Proven track record of leading teams and delivering high-quality code on time.',
  },
  experience: [
    {
      id: '1',
      company: 'Tech Solutions Inc.',
      role: 'Senior Frontend Developer',
      startDate: '2021-03',
      endDate: 'Present',
      description: 'Led the migration of legacy codebase to React. Improved site performance by 40%. Mentored junior developers.',
    },
    {
      id: '2',
      company: 'Digital Creative Agency',
      role: 'Web Developer',
      startDate: '2019-06',
      endDate: '2021-02',
      description: 'Developed responsive websites for various clients using HTML, CSS, and JavaScript. Collabortaed with designers to implement pixel-perfect UIs.',
    }
  ],
  education: [
    {
      id: '1',
      school: 'University of Technology',
      degree: 'B.S. in Computer Science',
      year: '2019',
    }
  ],
  skills: ['React', 'TypeScript', 'Tailwind CSS', 'Node.js', 'GraphQL', 'AWS'],
  sectionsOrder: ['experience', 'education', 'skills', 'custom_1'],
  customSections: [
    {
      id: 'custom_1',
      title: 'Projects',
      items: [
        {
          id: 'p1',
          name: 'Resume Builder',
          description: 'Built a full-featured resume builder with React and Tailwind CSS.',
          link: 'github.com/alex/resume-builder'
        }
      ]
    }
  ]
};
